import { useMutation } from '@tanstack/react-query';
import { api } from '@app/utils/api';
import { errorHandler } from '@app/utils/errorHandler';
import { IMainIndicatorsFilter } from 'pages/Main/components/Filter';
import { BI_BASE_URL } from '@app/contstants/endpoints';
import { IBoeingLine } from '@entities/boeing/IBoeingLine';
import { buildDateParams } from '@app/utils/buildDateParams';

export const fetch = async (filters: IMainIndicatorsFilter): Promise<IBoeingLine[]> => {
  const params = buildDateParams(filters);

  const response = await api.get<{
    data: { hashrate: string; date: string }[];
  }>(`${BI_BASE_URL}/boeing/line/hashrate`, {
    params: {
      manager_ids: filters.managers,
      region: filters.regions,
      tag: filters.tags,
      source: filters.sources,
      coins: filters.coins,
      ...params,
    },
  });

  const data = response.data ?? [];

  // @ts-ignore
  return data.map((item: { hashrate: string; date: string }) => ({
    value: item.hashrate,
    date: item.date,
  }));
};

export const useBoeingLineHashRate = () => {
  const { mutateAsync, isError, isPending, isSuccess, error } = useMutation({
    mutationFn: fetch,
    onError: error => errorHandler(error),
  });

  return {
    fetch: mutateAsync,
    isError,
    isPending,
    isSuccess,
    error,
  };
};
